var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCabinetOutline = function SvgCabinetOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828384",
    d: "M10 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10m3.333-5a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0M20 18.333C20 20 18.333 20 18.333 20H1.667S0 20 0 18.333c0-1.666 1.667-6.666 10-6.666s10 5 10 6.666m-1.667-.006c-.001-.41-.256-1.644-1.386-2.774-1.087-1.086-3.132-2.22-6.947-2.22s-5.86 1.134-6.947 2.22c-1.13 1.13-1.383 2.364-1.386 2.774z"
  })));
};
export default SvgCabinetOutline;